import { get, post } from './http';

export interface PointsLevelInfo {
  level: number;
  name: string;
  title: string;
  minPoints: number;
  maxPoints: number | null;
  color: string;
  icon: string;
  nextLevelName?: string;
}

export interface LeaderboardMember {
  email: string;
  name: string;
  company: string;
  points: number;
  historyCount: number;
  level?: PointsLevelInfo;
}

export interface AdminPointRecord {
  id: string;
  action: string;
  points: number;
  createdAt: string;
  targetTitle?: string;
  manualBy?: string;
}

export function getPointsLeaderboard(keyword?: string) {
  return get<LeaderboardMember[]>('/admin/points/leaderboard', keyword ? { params: { keyword } } : undefined);
}

export function getUserPointsLedger(email: string) {
  return get<AdminPointRecord[]>(`/admin/points/users/${email}/ledger`);
}

export function giftPointsToUser(email: string, payload: { points: number; reason: string }) {
  return post<{ message: string }>(`/admin/points/users/${email}/gift`, payload);
}

export interface MemberPointsSnapshotItem {
  email: string;
  points: number;
  level: PointsLevelInfo;
}

export function getMemberPointsSnapshot(emails: string[]) {
  return post<MemberPointsSnapshotItem[]>('/admin/points/snapshot', { emails });
}

export interface PublicPointsRule {
  key: string;
  label: string;
  rewardText: string;
  dailyLimitText: string;
  enabled: boolean;
}

export interface PublicPointsActivity {
  id: number;
  user: string;
  actionKey: string;
  actionLabel: string;
  pointsDelta: number;
  targetTitle: string | null;
  createdAt: string | null;
}

export interface PublicPointsLeaderboardItem {
  rank: number;
  displayName: string;
  points: number;
  level: PointsLevelInfo;
  avatarUrl: string | null;
}

export interface PublicPointsOverview {
  features: {
    invite: boolean;
    like: boolean;
    share: boolean;
    checkin: boolean;
  };
  pointsRules: PublicPointsRule[];
  levels: PointsLevelInfo[];
  leaderboard: PublicPointsLeaderboardItem[];
  activities: PublicPointsActivity[];
}

export function getPublicPointsOverview(limit = 6) {
  return get<PublicPointsOverview>('/public/points/overview', { params: { limit } });
}
